var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"official--partner-action-card"},[_c('Info',{attrs:{"developer_image":_vm.partner_image,"developer_web":_vm.partner_web,"name":_vm.name}}),(_vm.description)?_c('div',{staticClass:"action--description"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }